export const TEXT_LABEL = {
  KEY_STRENGTH: 'Key Strengths',
  DEVELOPMENT_AREA: 'Development Areas',
};
